export function createPermissionChecker(permissions = []) {
    const set = new Set(permissions);

    return {
        has: (permission) => set.has(permission),
        hasAny: (required) => required.some((permission) => set.has(permission)),
        hasAll: (required) => required.every((permission) => set.has(permission)),
    };
}

export function filterByPermission(items, has) {
    return items.filter((item) => {
        if (item.anyOf?.length) {
            return item.anyOf.some((permission) => has(permission));
        }
        return !item.permission || has(item.permission);
    });
}
